import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './acc/login';
import CreateGame from './before_start/createGame';
import Game from './game/game';
import WaitingRoom from './before_start/waitingRoom';
import Home from './home';
import SendMoney from './bank/sendMoney';
import Banc from './bank/bank';
import EndGame from './game/endGame';
import Spinner from './utils/spinner';
import Extras from './extras/extras';


const checkAvailability = async (token) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/checkAvailability`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: token }),
    });
    console.log("result"+ response);

    const result = await response.json();
    console.log("result"+ result);
    if (result.game_id && result.state) {
      localStorage.setItem('gameId', result.game_id);
      localStorage.setItem('gameName', result.game_name);
      return result.state;
    }
    else {
      localStorage.removeItem('gameId');
      localStorage.removeItem('gameName');
    }

  } catch (error) {
  console.error(error);
  localStorage.clear();
}


  return null;
};

const checkToken2 = async ({ setState, setLoggedIn, setActiveGame, setLoading }) => {
  const token = localStorage.getItem("userToken");

  if (token) {
    setState(await checkAvailability(token));
    setLoggedIn(true);
  } else {
    setLoggedIn(false);
  }

  const gameToken = localStorage.getItem("gameId");
  setActiveGame(!!gameToken);

  setLoading(false);
};

const WaitingRouteCheck = ({ element }) => {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [activeGame, setActiveGame] = useState(false);
  const [state, setState] = useState(null);

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    checkToken2({ setState, setLoggedIn, setActiveGame, setLoading });
  }, [currentPath]);

  console.log("Route Debug: ", { currentPath, activeGame, loggedIn, state });

  if (loading) {
    return <Spinner />;
  }

  if (!loggedIn && currentPath !== "/Login") {
    return <Navigate to="/Login" replace />;
  }

  if (loggedIn && currentPath === "/Login") {
    return <Navigate to="/" replace />;
  }

  if(currentPath === "/EndGame"){
    return element;
  }

  if (state === "waiting" && currentPath !== "/WaitingRoom" && activeGame) {
    return <Navigate to="/WaitingRoom" replace />;
  }

  if (!activeGame && currentPath !== "/WaitingRoom" && (currentPath === "/Game" || currentPath === "/Transaction" || currentPath === "/EndGame" || currentPath === "/Bank")) {
    return <Navigate to="/" replace />;
  }

  if (state === "playing" && (currentPath !== "/Game/Extras"  && currentPath !== "/Game"  && currentPath !== "/Transaction" && currentPath !== "/EndGame" && currentPath !== "/Bank") ) {
   return <Navigate to="/Game" replace />;
  }

  console.log('loading default element in nav!');
  return element;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WaitingRouteCheck element={<Home />} />} />
        <Route path="/CreateGame" element={<WaitingRouteCheck element={<CreateGame />} />} />
        <Route path="/Login" element={<WaitingRouteCheck element={<Login />} />} />
        <Route path="/Game" element={<WaitingRouteCheck element={<Game />} />} />
        <Route path="/WaitingRoom" element={<WaitingRouteCheck element={<WaitingRoom />} />} />
        <Route path="/Transaction" element={<WaitingRouteCheck element={<SendMoney />} />} />
        <Route path="/Bank" element={<WaitingRouteCheck element={<Banc />} />} />
        <Route path="/EndGame" element={<WaitingRouteCheck element={<EndGame />} />} />
        <Route path="/Game/Extras" element={<WaitingRouteCheck element={<Extras />} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
